var domain = 'admin.bodyfittraining.com'
switch (window.location.host.split('.')[0]) {
  default:
    domain = 'https://admin.bodyfittraining.com'
    break
  case 'staging-challenge':
  case 'staging-admin':
    domain = 'https://staging-admin.bodyfittraining.com'
    break
  case 'localhost:8100':
  case 'localhost:8101':
  case 'bft':
    domain = 'https://bft.localhost'
    break
}

const state = {
  imageUrl: domain + '/images/',
  baseUrl: domain + '/api/',
  //imageUrl: process.env.NODE_ENV === 'production' ? 'https://admin.bodyfittraining.com/images/' : 'https://admin.bodyfittraining.com/images/',
  //baseUrl: process.env.NODE_ENV === 'production' ? 'https://admin.bodyfittraining.com/api/' : 'https://admin.bodyfittraining.com/api/',
  //refresh_timeout: 1000 * 10
  refresh_timeout: 1000 * 60 * 60
}
const mutations = {

}
const actions = {

}
const getters = {
  baseUrl: state => {
    return state.baseUrl
  }
}
export default {
  namespaced: true, state, mutations, actions, getters
}
